import { render, staticRenderFns } from "./AttentionsByTypeBody.vue?vue&type=template&id=2ddb0bd2&"
import script from "./AttentionsByTypeBody.vue?vue&type=script&lang=js&"
export * from "./AttentionsByTypeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ddb0bd2', component.options)
    } else {
      api.reload('2ddb0bd2', component.options)
    }
    module.hot.accept("./AttentionsByTypeBody.vue?vue&type=template&id=2ddb0bd2&", function () {
      api.rerender('2ddb0bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/AttentionsByTypeBody.vue"
export default component.exports